import { getDialogHooks } from 'utilities/dialog-context/DialogContextHelpers';
import {
  TermConsentsDialog,
  TermConsentsDialogCallbackInput,
  TermConsentsDialogUniqueProps,
} from '../TermConsentsDialog';

const { useDialogForContext, useDialog: useTermConsentsDialog } =
  getDialogHooks<
    TermConsentsDialogUniqueProps,
    TermConsentsDialogCallbackInput
  >(TermConsentsDialog);

export const useTermConsentsDialogForContext = useDialogForContext;
export default useTermConsentsDialog;
